// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3193da64","455":"5e1b6cad"}[chunkId] + ".chunk.js";
};